import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { Input } from 'components/Input/Input'
import { useNavigate } from 'react-router-dom'
import { Button, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const Identity = ({ setStep, setState, state }: { setStep: (step: number) => void, setState?: any, state: any }) => {

    const navigate = useNavigate()

    const handleNext = () => setStep(2)
    const handleBack = () => navigate(-1)


    return <>


        <Container>
            <ContainerHeader>
                <TitleText>Identity</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <Input type='text' name='name' labelText='Name' placeholder='Q1 Mill Throughput Push' />
                <Input type='textarea' name='code' labelText='Notes' placeholder='MTP-Q1-2026' />

            </ContainerContent>

        </Container>
        <Flex gap='1rem' mt='32' justend>
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleNext} >Next</Button>
        </Flex>
    </>
}